import { createStore, applyMiddleware, compose } from 'redux';
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import * as redux from '@doctoroncallcom/redux';
import reducers from './reducers';
import api from '../utils/api';
import { persist, videoConsultation, rtm } from '../redux';

const persistConfig = {
  key: process.env.REACT_APP_APP_NAME,
  version: 1,
  storage,
  migrate: (state) => Promise.resolve(state),
  whitelist: [
    persist.rootReducerKey,
    videoConsultation.rootReducerKey,
    rtm.rootReducerKey,
  ],
};

const rootReducer = (state, action) => {
  const modifiedState = state;
  return reducers(modifiedState, action);
};

export const rootEpic = combineEpics(
  redux.user.epics.profile,
  redux.user.epics.updateProfile,
  redux.user.epics.postDocDigitalInfo,
  redux.user.epics.postDoctorPinEpic,
  redux.fileDomain.epics.getFileEpic,
  redux.fileDomain.epics.getFileTwoEpic,
  redux.fileDomain.epics.getMultipleFileEpic,
  redux.fileDomain.epics.uploadFilesEpic,
  redux.fileDomain.epics.getUploadFilesUrlEpic,
  redux.fileDomain.epics.getFileAndAppendUserEpic,
  redux.consultations.epics.getDoctorConsultationHistoryList,
  redux.consultations.epics.getConsultationHistoryDetails,
  redux.consultations.epics.getAvailableConsultationsList,
  redux.consultations.epics.getPatientConsultationRecordEpic,
  redux.consultations.epics.getDoctorConsultationOverview,
  redux.consultations.epics.assignDocToConsultationEpic,
  redux.consultations.epics.postDoctorMCEpic,
  redux.consultations.epics.postDoctorNotesEpic,
  redux.consultations.epics.postDoctorReferralEpic,
  redux.consultations.epics.endDoctorConsultationEpic,
  redux.consultations.epics.sendAudioCallRequestByDocEpic,
  redux.consultations.epics.getDoctorReferralNewLinkEpic,
  redux.consultations.epics.getDoctorMCNewLinkEpic,
  redux.appointments.epics.getDoctorAppointmentOverview,
  redux.consultations.epics.getDoctorTwilioTokensEpic,
  redux.consultations.epics.postDocConsultationTimeLapsedEpic,
  redux.consultations.epics.getPrescriptionIdEpic,
  redux.consultations.epics.regenerateAgoraTokenEpic,
  redux.appointments.epics.getDoctorAppointmentList,
  redux.alerts.epics.getAlertsList,
  redux.prescriptions.epics.postDoctorPrescriptionSearchEpic,
  redux.prescriptions.epics.postDoctorPrescriptionDataEpic,
  redux.prescriptions.epics.getPatientPrescriptionDataEpic,
  redux.prescriptions.epics.getDoctorPrescriptionNewLinkEpic,
  redux.prescriptions.epics.postDoctorEditPrescriptionSearchEpic,
  redux.prescriptions.epics.postForPrescriptionNotificationDataEpic,
  redux.chat.epics.postChatDataEpic,
  redux.chat.epics.getChatDataEpic,
  redux.otp.epics.otpCode,
  redux.trustgate.epics.getCertificateInfo,
  redux.icd.epics.getIcdList,
  redux.icd.epics.getIcdDoctorList,
  redux.icd.epics.getIcd
);
const epicMiddleware = createEpicMiddleware({
  dependencies: { api },
});

export default function configureStore(initialState = {}) {
  let composeEnhancers = compose;

  // If Redux Dev Tools and Saga Dev Tools Extensions are installed, enable them
  /* istanbul ignore next */
  if (process.env.NODE_ENV !== 'production' && typeof window === 'object') {
    /* eslint-disable no-underscore-dangle */
    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});
  }

  const middlewares = [epicMiddleware];

  const enhancers = [applyMiddleware(...middlewares)];

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(...enhancers)
  );

  epicMiddleware.run(rootEpic);

  const persistor = persistStore(store);

  // Extensions
  store.injectedReducers = {}; // Reducer registry
  store.injectedSagas = {}; // Saga registry
  store.persistor = persistor;

  return { store, persistor };
}
